export { Size } from '../../../es/_util/enum';
export var WaitType;
(function (WaitType) {
    WaitType["throttle"] = "throttle";
    WaitType["debounce"] = "debounce";
})(WaitType || (WaitType = {}));
